import { render, staticRenderFns } from "./LessonCreate.vue?vue&type=template&id=4e1e0c73&scoped=true&"
import script from "./LessonCreate.vue?vue&type=script&lang=ts&"
export * from "./LessonCreate.vue?vue&type=script&lang=ts&"
import style0 from "./LessonCreate.vue?vue&type=style&index=0&id=4e1e0c73&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1e0c73",
  null
  
)

export default component.exports